import React, { useState, useContext } from 'react'
import { M_Fieldset, M_InputTextField, LoadingContext, M_Button, BufferService } from 'src/M_Components'
import { Clear, Done } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const ChangePassword = ({ Email }) => {
    const ctx = useContext(LoadingContext)
    const [values, setValues] = useState(new Map([]))
    const passwordService = new BufferService('identity/updatepassword')
    const { t } = useTranslation()

    const changeValues = (obj, key) => {
        values.set(key, obj)
        setValues(new Map(values))
    }


    const submitPass = () => {
        ctx.setIsLoad(true)
        if (values.get("pass") === values.get("newPass")) {
            ctx.toastMessages('error', t('SamePassword'))
            ctx.setIsLoad(false)
            return
        }
        if (values.get("newPass") !== values.get("confNewPass")) {
            ctx.toastMessages('error', t('PasswordConfirmationFailed'))
            ctx.setIsLoad(false)
            return
        }

        const tempObj = {
            "email": Email,
            "oldPassword": values.get("pass"),
            "newPassword": values.get("newPass")
        }

        passwordService.update('', tempObj).then(res => {
            ctx.setIsLoad(false)
            if (res.name === 'AxiosError') {
                ctx.toastMessages('error', res.response.data.Errors.toString())
                return
            }
            ctx.toastMessages('success', t("PasswordAlterada"))
            setValues(new Map())
        })
    }

    return (
        <div>
            <M_Fieldset
                labelInside
                label={t('ChangePassword')}
                elements={
                    <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '20px' }}>
                        <M_InputTextField
                            label={t("OldPassword")}
                            value={values.get('pass') || ''}
                            type={"password"}
                            onChange={(e) => changeValues(e.target.value, 'pass')}
                        />
                        <div></div>
                        <M_InputTextField
                            label={t("NewPassword")}
                            value={values.get('newPass') || ''}
                            type={"password"}
                            onChange={(e) => changeValues(e.target.value, 'newPass')}
                        />
                        <M_InputTextField
                            label={t("ConfirmPassword")}
                            value={values.get('confNewPass') || ''}
                            type={"password"}
                            onChange={(e) => changeValues(e.target.value, 'confNewPass')}
                        />
                        <div></div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px' }}>
                            <M_Button
                                label={"Cancel"}
                                icon={<Clear style={{ color: 'var(--color-white)' }} />}
                                backgroundColor={'var(--color-red)'}
                                labelColor={'var(--color-white)'}
                                onClick={() => { setValues(new Map([])) }}
                            />
                            <M_Button
                                label={"Save"}
                                icon={<Done style={{ color: 'var(--color-white)' }} />}
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                                onClick={() => { submitPass() }}
                            />
                        </div>
                    </div>
                }
            />
        </div>
    )
}
